module.exports = __webpack_public_path__ + "static/media/enabledNextIcon.01b685b6.svg";